import { RowCrudStatus } from "../../common/types";
import {
  Platform,
  PlatformCreateMutationVariables,
  PlatformUpdateMutationVariables,
} from "../../../api/graphql";
import { LangStore } from "../../../store";

export type PlatformValuesType = {
  id: string;
  displayId: string;
  version_: string;
  __status__: RowCrudStatus;
  name: string;
};

export type PlatformErrorsType = {
  name?: { message: string; fieldLabel: string };
};

export function PlatformValuesInit(): PlatformValuesType {
  return {
    id: "",
    displayId: "",
    version_: "",
    __status__: "empty",
    name: "",
  };
}

export type PlatformType = Platform | PlatformValuesType;

export function platformDisplayId(
  source: Partial<Platform>,
  _langStore: LangStore
) {
  return source.name ?? _langStore.emptyStringSymbol;
}

export function getPlatformValues(
  source: PlatformType,
  _langStore: LangStore,
  _duplicated: boolean = false
): PlatformValuesType {
  const entityValues = PlatformValuesInit();
  entityValues.id = source.id;
  entityValues.displayId =
    "__status__" in source
      ? source.displayId
      : platformDisplayId(source, _langStore);
  entityValues.version_ = source.version_;
  entityValues.name = source.name;
  if (_duplicated) {
    entityValues.__status__ = "added";
  } else if ("__status__" in source) {
    entityValues.__status__ = source.__status__;
  }
  return entityValues;
}

export function getPlatformUpdateVariables(
  values: PlatformValuesType
): PlatformUpdateMutationVariables {
  return {
    id: values.id,
    version_: values.version_,
    name: values.name,
  };
}

export function getPlatformCreateVariables(
  values: PlatformValuesType
): PlatformCreateMutationVariables {
  return {
    name: values.name,
  };
}
